var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.99v9.009a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5v-9.12l-24 .11zM19 3h-6.528a1.02 1.02 0 0 1-.447-.1L8.869 1.316A3.014 3.014 0 0 0 7.528 1H5a5.006 5.006 0 0 0-5 5v.99l23.863-.11A5 5 0 0 0 19 3z",
    fill: "#5E6175"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.80ee1f23a6e7b5dbc0f894b0c64ca5e6.svg";
export { ForwardRef as ReactComponent };